import axios from 'axios';
import Vue from "vue";
import { sessionStore } from '@/utils/data-management'
import BASE from '@/api/base.js';
import md5 from 'js-md5';
import StringUtils from './stringutils';
import { Message } from 'element-ui';
import  router  from  '../router'
import  store  from  '../store'
import * as secret from '@/utils/secret';
// 创建axios实例
let instance = axios.create({
    timeout: 1000 * 12
});
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
    config => {
        if (config.url.indexOf(BASE.GJSC) !== -1) {
            return config;
        }
        const loginInfo = sessionStore.get('userInfo')
        const zctToken = sessionStore.get("zctToken");
        // const headers = {};
        if (loginInfo) {
            config.headers = {
                ...config.headers,
                token: loginInfo.token || '',
                'key-token': loginInfo.token || ''
            }

        }
        const timestamp = new Date().getTime() + '';
        const nonce = StringUtils.randomStr(32);
        const encrptString = `${timestamp}.${BASE.ZCT_SECRET}.${nonce}`;
        const sign = md5(encrptString);
        config.headers = {
            ...config.headers,
            sign,
            timestamp,
            nonce,
            zctToken: zctToken
        }
        // console.log('入参===', config.data)
        const result = config.url && config.url.indexOf("/file/upload") > -1
        if (!result && config.method && config.method.toLocaleUpperCase() == "POST") {
            config.data = secret.default.encrypt(JSON.stringify(config.data));
            config.headers['Content-Type'] = 'application/json';
        }
        return config;
    },
    error => Promise.error(error)
);

// 响应拦截器
instance.interceptors.response.use(
    // 请求成功
    res => {
        if (res.status === 200) {
            if  (res.data  &&  Object.prototype.toString.call(res.data)  ===  '[object String]')  {
                res.data  =  JSON.parse(secret.default.decrypt(res.data))    
            }
            if (res.data.code != 1000) {
                if (res.data.code == 3000) {
                    sessionStore.remove('zctToken')
                    store.dispatch('getToken',  'show')
                    // router.push('/home')
                        // window.location.replace("http://baise-portal-pc.baise.whdev.vpclub.cn/#/home/workHall")
                    Message.closeAll()
                }
                Message({
                    dangerouslyUseHTMLString: true,
                    message: res.data.message || res.data.msg,
                    type: 'error'
                });
            }
            return Promise.resolve(res.data)
        } else {
            return Promise.reject(res)
        }
    },
    // 请求失败
    error => {
        const { response } = error;
        if (response) {
            // 请求已发出，但是不在2xx的范围
            // errorHandle(response.status, response.data.message);
            return Promise.reject(response);
        } else {
            // 处理断网的情况
        }
    }
);
export default instance;
